/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nrl_Loaderror2Inputs */

const en_coinvestments_nrl_loaderror2 = /** @type {(inputs: Coinvestments_Nrl_Loaderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading Non-Release Letters. Please try again.`)
};

/**
* | output |
* | --- |
* | "Error loading Non-Release Letters. Please try again." |
*
* @param {Coinvestments_Nrl_Loaderror2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nrl_loaderror2 = /** @type {((inputs?: Coinvestments_Nrl_Loaderror2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nrl_Loaderror2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nrl_loaderror2(inputs)
});
export { coinvestments_nrl_loaderror2 as "coInvestments_nrl_loadError" }